// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"554":"0e31fef5","652":"9333e679","787":"6e524460"}[chunkId] + ".chunk.js";
};